jQuery(function ($) {
    $('#cooperative-load-more').click(function () {
        $(this).addClass('is-loading loading-start').attr("disabled", true);
        let ajaxUrl = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}/wp-admin/admin-ajax.php`;
        let truePosts = $(this).data('true-posts');
        let currentPage = $(this).data('current-page');
        let maxPages = $(this).data('max-pages');
        let postPerLoad = $(this).data('post-per-page');

        let data = {
            'action': 'load_cooperative_posts',
            'query': truePosts,
            'page': currentPage,
            'post-per-load': postPerLoad,
        };

        $.ajax({
            url: ajaxUrl,
            data: data,
            type: 'POST',
            success: function (data) {
                if (data) {
                    $('#cooperative-load-more').removeClass('is-loading loading-start').attr("disabled", false);
                    $('#cooperative-articles').append(data);
                    currentPage++;
                    $('#cooperative-load-more').data('current-page', currentPage);
                    if (currentPage === maxPages) $("#cooperative-load-more").remove();

                    setTimeout(function () {
                        $('#cooperative-articles').find('.card-animation').removeClass('card-animation');
                    }, 1);
                } else {
                    $('#cooperative-load-more').remove();
                }
            }
        });
    });
});